import { useInspectorMode } from "@utils/ContentfulUtils";
import { getLink } from "@utils/linkUtils";
import { useLocale } from "next-intl";
import Link from "next/link";
import { FC } from "react";

import Image from "@/components/ui/Image/Image";
import { TileCarouselCardProps } from "@/types";

import RichText from "../RichText/RichText";
import TileCarouselCardContent from "./TileCarouselCardContent";

const TileCarouselCard: FC<{ item: TileCarouselCardProps; openModal: () => void }> = ({ item, openModal }) => {
  const locale = useLocale();
  const inspectorMode = useInspectorMode(item.id);
  return (
    <>
      {item.link ? (
        <Link href={getLink(item.link, locale)} target={item.link?.link?.target}>
          <div className="w-full md:w-fit relative mb-m md:mb-0">
            {item?.video ? (
              <video
                className="aspect-2-1 w-full md:w-[255px] h-[453px] rounded-lg shadow-elevation object-cover"
                poster={item?.image?.url}
                muted
                autoPlay
                loop
                playsInline
                {...inspectorMode.getProps("video")}
              >
                {item.video && <source src={item.video.url} type="video/mp4" />}
              </video>
            ) : (
              item.image && (
                <div className="relative overflow-hidden w-full md:w-[255px] h-[453px] rounded-lg shadow-elevation">
                  <Image
                    src={item.image.url}
                    width={255}
                    height={453}
                    className="aspect-2-1 w-full md:w-[255px] h-[453px] rounded-lg shadow-elevation transform duration-300 ease-in-out hover:scale-105"
                    alt={item.image.title || ""}
                  />
                  {item.logo && <div className="absolute w-full h-full top-0 left-0 inset-0 img-overlay-5"></div>}
                </div>
              )
            )}

            {item.logo && (
              <div className="absolute bottom-0 top-0 text-white pt-xs flex justify-center w-1/2 mx-auto left-0 right-0">
                <Image
                  src={item.logo.url}
                  width={item.logo.width || 128}
                  height={item.logo.height || 72}
                  className="h-fit"
                  alt={item.logo.title || ""}
                />
              </div>
            )}
            <div
              className="absolute bottom-0 z-10 text-center text-white px-s pb-m w-full tile-carousel-content"
              style={{ color: item.titleColor ? item.titleColor : undefined }}
            >
              {item?.overtitle && <div className="font-primary font-normal text-xs pb-xs">{item.overtitle}</div>}
              <div className="font-primary text-m font-medium leading-5 pb-xxs tile-carousel-title">{item.title}</div>
              {item?.abstract && <div className="font-primary text-s leading-4 tile-carousel-description">{item.abstract}</div>}
              {item?.abstractRtf && !item?.abstract && (
                <div className="font-primary text-s leading-4 tile-carousel-description">
                  <RichText content={item.abstractRtf} />
                </div>
              )}
            </div>
          </div>
        </Link>
      ) : item.modal ? (
        <button onClick={openModal} className="block w-full">
          <TileCarouselCardContent item={item} openModal={openModal} />
        </button>
      ) : (
        <TileCarouselCardContent item={item} openModal={openModal} />
      )}
    </>
  );
};
export default TileCarouselCard;
